import React, { useEffect } from "react";
import i18n from "../../../i18n/i18n";
import { Button, Form } from "react-bootstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { patchMaterialTypeById, postNewMaterialType } from "./core/_request";
import { ActionedMaterialType } from "./store/MaterialTypeStore";
import { toast } from "sonner";

const RoleSchema = Yup.object().shape({
  name: Yup.string()
    .min(4, "Type de matériel doit avoir au moins 4 caractères")
    .required("Type de matériel obligatoire"),
});

type RoleFormData = {
  name: string;
};

type RoleFormProps = {
  onCreated?: (role: any) => void;
  actioned?: ActionedMaterialType | null;
  open?: boolean;
};

const MaterialTypeForm = ({ onCreated, actioned, open }: RoleFormProps) => {
  const roleForm = useFormik<RoleFormData>({
    initialValues: {
      name: "",
    },
    validationSchema: RoleSchema,
    onSubmit: async (values) => {
      if (roleForm.isValid) {
        const res = actioned
          ? await patchMaterialTypeById(actioned?.data?.id?.toString(), values)
          : await postNewMaterialType(roleForm.values);
        if (res) {
          
          console.log("Type de matériel créée : ", res);
          if (res?.response?.data?.status === 422) {
            roleForm.setErrors({
              name: res?.response?.data?.violations?.find((errr: any) => {
                return errr?.propertyPath === 'name'
              })?.message
            })
            return;
          }
          
          roleForm.resetForm();
          if (onCreated) {
            onCreated(res);
          }
          toast.success('Type de matériel ' + (actioned ? ' modifié ' : ' créé ') + ' avec succès')
        } else {
          toast.error('Une erreur de ' + (actioned ? ' modification ' : ' création ') + ' du type de matériel')
        }
      }
    },
  });
  useEffect(() => {
    if (actioned) {
      roleForm.setValues({ name: actioned?.data?.name });
    } else {
      roleForm.resetForm();
      roleForm.setTouched({
        name: false,
      });
    }
  }, [actioned]);
  useEffect(() => {
    roleForm.setTouched({
      name: false,
    });
  }, [open]);
  if (actioned?.action === "read") {
    return (
      <div className="detail-view">
        <div className="d-flex">
          <Form.Label className="fw-bold me-1">{"Libellé : "}</Form.Label>
          <div>{actioned?.data?.name}</div>
        </div>
        {/* <div className="d-flex">
          <Form.Label className="fw-bold">Catégorie de conteneur : </Form.Label>
          <div>
            {actioned?.data?.containerCategory?.name}
          </div>
        </div> */}
      </div>
    );
  }
  return (
    <Form onSubmit={roleForm.handleSubmit}>
      <div className="row">
        <div className="col-4">
          <h4>{"Type de matériel"}</h4>
          <div className="pb-3">
            <Form.Label className="fw-bold">Libellé</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={roleForm.values.name}
              onChange={roleForm.handleChange}
            />
            {roleForm.touched.name && (
              <span className="text-danger fs-10">
                {roleForm.errors?.name ?? ""}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="pt-2">
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </div>
    </Form>
  );
};

export default MaterialTypeForm;
